import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { AuthProvider, useAuth } from "./context/AuthContext";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Work from "./pages/Work";
import Collaborate from "./pages/Collaborate";
import MeetConsultant from "./pages/MeetConsultant";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

// scroll-to-top on route change
const ScrollTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => window.scrollTo({ top: 0, behavior: "instant" }), [pathname]);
  return null;
};

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink/60" data-testid="auth-loading">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="pt-20 lg:pt-24">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App bg-cream text-ink font-sans">
      <BrowserRouter>
        <AuthProvider>
          <ScrollTop />
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
            <Route path="/meet" element={<PublicLayout><MeetConsultant /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><Services /></PublicLayout>} />
            <Route path="/work" element={<PublicLayout><Work /></PublicLayout>} />
            <Route path="/collaborate" element={<PublicLayout><Collaborate /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
